import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const fmtPrice = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(n);

// Compute effective unit price given per-product tiers and quantity
export const effectivePrice = (basePrice, tiers, qty) => {
  let price = Number(basePrice);
  (tiers || [])
    .slice()
    .sort((a, b) => a.min_qty - b.min_qty)
    .forEach((t) => {
      if (qty >= t.min_qty) price = Number(t.price);
    });
  return Math.round(price * 100) / 100;
};

// FastAPI error detail can be a string or array of {msg} objects
export const formatApiErrorDetail = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};
